import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HttpStatus } from '@ciceksepeti/cs-http-status';
import IconCiceksepeti from '@components/icon-ciceksepeti/icon-ciceksepeti';
import PopularCategories from '@components/popular-categories';
import { useResponsive } from '@hooks/use-responsive';
import '@ciceksepeti/cs-http-status/styles.css';
import '@ciceksepeti/cs-button/styles.css';
import styles from './styles.module.scss';
var NotFoundError = function () {
    var isMobileDevice = useResponsive().isMobileDevice;
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx(HttpStatus, { isMobile: isMobileDevice, code: "404", title: "\u00DCzg\u00FCn\u00FCz! Arad\u0131\u011F\u0131n\u0131z sayfay\u0131 bulamad\u0131k.", subTitle: _jsxs(_Fragment, { children: ["B\u00F6yle bir sayfa hi\u00E7 olmad\u0131 ya da bir \u015Feyler ters gidiyor.\uD83E\uDD72 ", _jsx("br", {}), " Sorun de\u011Fil, anasayfa \u00FCzerinden al\u0131\u015Fveri\u015Fe ba\u015Flayabilir veya pop\u00FCler kategorilere g\u00F6z atabilirsiniz."] }), buttonProps: {
                    children: 'Anasayfaya Git',
                    dimension: 'xlarge',
                    startIcon: _jsx(IconCiceksepeti, {})
                } }), _jsx(PopularCategories, {})] }));
};
export default NotFoundError;
